import { SearchchatComponent } from "./../searchchat/searchchat.component";
import { Component, OnInit, ViewChild } from "@angular/core";
import { IonContent, Platform } from "@ionic/angular";
import { ModalController, IonInfiniteScroll, NavController } from "@ionic/angular";
import { CartComponent } from "../cart/cart.component";
import { mensaje } from "src/app/models/mensaje.model";
import { ApiService } from "../../api.service";
import { Camera, CameraOptions } from "@ionic-native/camera/ngx";
import { GlobalService } from "../../services/global.service";
import { File } from "@ionic-native/file/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { FileChooser } from "@ionic-native/file-chooser/ngx";
import { FilePath } from "@ionic-native/file-path/ngx";
import { HttpClient } from "@angular/common/http";
import { HTTP } from "@ionic-native/http/ngx";
import { WebView } from "@ionic-native/ionic-webview/ngx";
import { ProductDetailsComponent } from "../product-details/product-details.component";
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic/ngx";
import { DocumentViewer } from "@awesome-cordova-plugins/document-viewer/ngx";
import { PreviewAnyFile } from "@ionic-native/preview-any-file/ngx";
import { OrdersComponent } from "../orders/orders.component";

@Component({
    selector: "app-chat",
    templateUrl: "./chat.component.html",
    styleUrls: ["./chat.component.scss"],
})
export class ChatComponent implements OnInit {
    @ViewChild("IonContent", { static: true }) content: IonContent;
    @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;

    public static instance: ChatComponent;

    public static isShown(): boolean {
        if (ChatComponent.instance) {
            return true;
        } else {
            return false;
        }
    }
    start_typing: any;
    nickname: string;
    message: string;
    profile: any;
    archivo: Blob;
    loader: boolean;
    resultado: mensaje;
    chats: mensaje[];
    chatsOrden: mensaje[];
    cargandoMensajesRemotos: boolean;
    clickedImage: string;
    nombreFichero: string;
    rutaFichero: string;
    carpetaFichero: string;
    tipofichero: string;
    previmagen: string;
    prevnombre: string;
    prevprecioVenta: string;
    prevcodigo: string;
    articulo: any;
    archivoNavegador: File = null;
    articuloadjunto: string;
    articuloprecio: string;
    articuloref: string;
    footerHidden: boolean;
    preview: boolean;
    tipomensaje: string = "mensaje";
    url: string;
    showOptions: boolean = false;
    scrollDepthTriggered: boolean = false;
    public imagePath;
    options: CameraOptions = {
        quality: 30,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
    };

    constructor(private document: DocumentViewer, private navController: NavController, private fcm: FCM, private webview: WebView, private http: HTTP, private httpClient: HttpClient, public file: File, private fileOpener: FileOpener, private fileChooser: FileChooser, private filePath: FilePath, public global: GlobalService, public modalController: ModalController, private apiService: ApiService, public camera: Camera, private platform: Platform, public previewAnyFile: PreviewAnyFile) {}

    /*Manejadores de eventos de ventana*/
    ngOnInit() {
        console.log("Inicializando ventana de chat");
        console.log(this.global.itemChat);
        this.loader = true;
        this.cargandoMensajesRemotos = false;
        this.nombreFichero = "";
        this.prevcodigo = "";
        this.chats = [];
        this.loader = false;
    }
    ionViewDidLeave() {
        console.log("Chat ocultado");
        ChatComponent.instance = null;
    }

    async ionViewDidEnter() {
        ChatComponent.instance = this;
        this.cargaChat();
        console.log(this.platform);
        if (this.platform.is("desktop") || this.platform.is("mobileweb")) {
            setInterval(() => {
                this.cargaUltimos();
            }, 100000);
        }
        this.global.mensajesSinLeer = 0;

        if (this.global.itemChat !== undefined) {
            console.log(this.global.itemChat);
            this.articulo = JSON.stringify(this.global.itemChat);
            this.tipofichero = "articulo";
            this.tipomensaje = "articulo";
            this.previmagen = this.global.itemChat.imagen;
            this.prevnombre = this.global.itemChat.nombre;
            this.prevprecioVenta = this.global.itemChat.precioVenta;
            this.prevcodigo = this.global.itemChat;
            this.preview = true;
            this.scrollDown();
        }

        this.scrollDown();
        console.log("Chat mostrado");
    }
    /* Carga de chats */

    async cargaChat() {
        console.log("Cargando mensajes inicio");
        let chatstemp = [];
        const url = this.global.host + "/api/chatn/mensajesanteriores/" + this.global.usuarioId + "?idUltimoMensajeObtenido=-1";
        chatstemp = await this.apiService.chatMensajes(url);

        let idLeido: number;

        idLeido = 0;

        chatstemp.reverse().forEach((element) => {
            element.numero = idLeido++;

            if (element.userId.includes("agente")) {
                //del proveedor
                element.propio = false;
                element.classIncial = "received";
            } else {
                element.classIncial = "send";
                element.propio = true;
            }
        });

        console.log(chatstemp);

        chatstemp = chatstemp.sort((a, b) => a.id - b.id);
        const urlM = this.global.host + "/api/chatn/marcarLeido/" + this.global.usuarioId;
        await this.apiService.marcarLeidos(urlM);
        if (chatstemp == null || chatstemp.length === 0) {
            console.log("Sin mensajes, salgo.");
            this.cargandoMensajesRemotos = false;
            return;
        } else {
            this.chats = chatstemp;
            chatstemp = null;
            console.log("Fin de carga de mensajes.");
            this.scrollDown();
        }
    }

    //Carga los mensajes anteriores a los que tenemos en el array
    async cargaAnteriores(ultimoID) {
        console.log("Arriba y " + this.cargandoMensajesRemotos);
        if (this.cargandoMensajesRemotos) {
            return;
        }
        ultimoID = ultimoID - 2;
        this.cargandoMensajesRemotos = true;
        this.chatsOrden = null;
        this.url = this.global.host + "/api/chatn/mensajesanteriores/" + this.global.usuarioId + "?idUltimoMensajeObtenido=" + ultimoID;
        console.group("Url: " + this.url);
        this.chatsOrden = await this.apiService.chatMensajes(this.url);
        //this.chatsOrden = this.chats.sort((a,b)=> b.id-a.id);
        //await this.apiService.cambiarEstadoMensajes(chatstemp, 2);  // Cambio el estado a leido
        const urlM = this.global.host + "/api/chatn/marcarLeido/" + this.global.usuarioId;
        await this.apiService.marcarLeidos(urlM);
        if (this.chatsOrden == null || this.chatsOrden.length === 0) {
            // Sin mensajes
            console.log("Sin mensajes, salgo.");
            return;
        } else {
            console.log(this.chatsOrden);
            this.chats.reverse();
            console.log(this.chats);
            for (let i = 0; i < this.chatsOrden.length; i++) 
            {
                console.log(this.chatsOrden[i]);
                if (this.chatsOrden[i].userId.includes("agente")) {
                    this.chatsOrden[i].propio = false;
                    this.chatsOrden[i].classIncial = "received";
                } else {
                    this.chatsOrden[i].classIncial = "send";
                    this.chatsOrden[i].propio = true;
                }
                this.chats.push(this.chatsOrden[i]);
            }
            this.chats.reverse();
            this.chatsOrden = null;
            this.cargandoMensajesRemotos = false;
            console.log("Fin de carga de mensajes.");
        }
    }

    //consulta y carga los siguintes que van llegando o los que mandamos
    async cargaUltimos() {
        console.log("Cargando ultimos " + this.getUltimoIDObtenido());
        /*console.log(this.chats.length);
      console.log(this.chats[this.chats.length].id);*/
        this.chatsOrden = null;
        const url = this.global.host + "/api/chatn/mensajesposteriores/" + this.global.usuarioId + "?idUltimoMensajeObtenido=" + this.getUltimoIDObtenido();
        console.log(url);
        console.log(this.chatsOrden);
        this.chatsOrden = await this.apiService.chatMensajes(url);
        //await this.apiService.marcarLeidos();
        if (this.chatsOrden == null || this.chatsOrden.length === 0) {
            // Sin mensajes
            console.log("Sin mensajes, salgo.");
            return;
        } else {
            console.log(this.chatsOrden);
            this.chatsOrden.reverse();
            for (let i = 0; i < this.chatsOrden.length; i++) {
                console.log(this.chatsOrden[i]);

                if (this.chatsOrden[i].userId.includes("agente")) {
                    this.chatsOrden[i].propio = false;
                    this.chatsOrden[i].classIncial = "received";
                } else {
                    this.chatsOrden[i].classIncial = "send";
                    this.chatsOrden[i].propio = true;
                }

                this.chats.push(this.chatsOrden[i]);
            }
            
            console.log(this.chats);
            this.chatsOrden = null;
            this.cargandoMensajesRemotos = false;
            console.log("Fin de carga de mensajes.");
            const urlM = this.global.host + "/api/chatn/marcarLeido/" + this.global.usuarioId;
            console.log(urlM);
            this.apiService.marcarLeidos(urlM);
        }
    }

    /*Auxiliares */
    getUltimoIDObtenido() {
        // El mas antiguo
        console.log("Longitud del chat: " + this.chats.length);
        if (this.chats.length === 0) {
            return -1;
        }
        console.log("Id del último obtenido: " + this.chats[this.chats.length - 1].id);
        return this.chats[this.chats.length - 1].id;
    }

    getPrimerIDObtenido() {
        // El mas nuevo
        if (this.chats.length === 0) {
            return -1;
        }
        console.log(this.chats[0].id + 1);
        return this.chats[0].id + 1;
    }

    dameruta(array) {
        let jsonruta = JSON.parse(array);
        let html = '<br/><br/><div class="imgcont"><img class="img" src="' + jsonruta.imagen + '" style="margin:0px !important"></div><p class="mensaje">' + jsonruta.nombre + '</p><p class="textprecio">' + jsonruta.precioVenta + '€</p><p class="textref">Ref: ' + jsonruta.codigo + "</p>";
        return html;
    }

    damecodigo(array) {
        let jsonruta = JSON.parse(array);
        return jsonruta;
    }

    /*scroll del div */

    scrollDown() {
        setTimeout(() => {
            this.content.scrollToBottom(50);
        }, 250);
    }

    async scrolled(event) {
        const scrollElement = await event.target.getScrollElement();
        const currentScrollDepth = event.detail.scrollTop;

        if (currentScrollDepth < 40) {
            console.log(this.getPrimerIDObtenido());
            console.log("Llega arriba");
            await this.cargaAnteriores(this.getPrimerIDObtenido());
        }
    }

    scrollTo(element: number) {
        try {
            console.log("Scroll a : " + "item" + element);
            let e = document.getElementById("item" + element);
            if (e == null) {
                console.log("Elemento no encontrado");
                return;
            }
            let yOffset = e.offsetTop;
            this.content.scrollToPoint(0, yOffset, 0);
        } catch (ex) {}
    }

    /*Dentro de los mensajes*/

    cambio() {
        console.log(this.message);

        if (this.message !== "") {
            const arr: string[] = this.message.split("");
            arr[0] = arr[0].toUpperCase();
            this.message = arr.join("");
        }
    }

    cerrarPreview() {
        this.global.itemChat = undefined;
        this.rutaFichero = "";
        this.archivo = null;
        this.previmagen = "";
        this.prevnombre = "";
        this.prevprecioVenta = "";
        this.prevcodigo = "";
        this.tipomensaje = "";
        this.preview = false;
        this.showOptionsToggle(false);
        // Si queremos volver atrás this.navController.back();
    }

    abre(ruta) {
        console.log(this.global.host + ruta);

        if (this.platform.is("desktop") || this.platform.is("mobileweb")) {
            window.open(encodeURI(this.global.host + ruta), "_system", "location=yes");
        } else {
            this.previewAnyFile.preview(this.global.host + ruta).then(
                () => {},
                (err) => {
                    alert(JSON.stringify(err));
                }
            );
        }
    }

    async abreDoc(documento) {
        console.log(documento);
        let obj = JSON.parse(documento);
        console.log(obj.codigo);
        const modal = await this.modalController.create({
            component: OrdersComponent,
            componentProps: { codigo: obj.codigo },
        });
        return await modal.present();
    }

    PickAnyFile(tipo) {
        this.preview = false;
        this.fileChooser.open().then((fileuri) => {
            this.filePath.resolveNativePath(fileuri).then((nativepath) => {
                this.rutaFichero = this.webview.convertFileSrc(nativepath);
                this.nombreFichero = nativepath.substring(nativepath.lastIndexOf("/") + 1);
                this.carpetaFichero = nativepath.substring(0, nativepath.lastIndexOf("/") + 1);
                let folder = nativepath.substring(0, nativepath.lastIndexOf("/") + 1);
                this.file.readAsDataURL(folder, this.nombreFichero).then((str) => {
                    var arr = str.split(";");
                    var arr1 = arr[0].split(":");
                    var mimetype = arr1[1];
                    this.tipofichero = tipo;
                    this.tipomensaje = tipo;
                    this.openfile(nativepath, mimetype);
                    this.preview = true;
                });
            });
        });
    }

    //para coger ficheros no nativo
    desdeNavegador(imgFile: any) {
        if (imgFile.target.files && imgFile.target.files[0]) {
            this.nombreFichero = "";
            Array.from(imgFile.target.files).forEach((file: File) => {
                this.nombreFichero += file.readAsText + " - ";
            });
            // HTML5 FileReader API
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.rutaFichero = e.target.result;
                let image = new Image();
                image.src = e.target.result;
                image.onload = (rs) => {
                    let imgBase64Path = e.target.result;
                     (imgBase64Path);
                    this.tipofichero = "imagen";
                    this.tipomensaje = "imagen";
                    this.preview = true;
                    this.scrollDown();
                };
            };
            reader.readAsDataURL(imgFile.target.files[0]);
            this.archivo = imgFile.target.files[0];
            console.log(this.archivo);
            this.nombreFichero = imgFile.target.files[0].name;
            console.log("Fichero cargado : " + this.nombreFichero);
        }
    }

    async openfile(filepath, mimetype) {
        try {
            const buffer = await this.file.readAsArrayBuffer(this.carpetaFichero, this.nombreFichero);
            //alert('buffer');
            this.archivo = new Blob([buffer], { type: mimetype });
        } catch (error) {
            //alert(`Buffering failed ${JSON.stringify(error)}`)
        } finally {
            //alert('Cargado');
            console.log(this.archivo.size);
            this.preview = true;
            this.scrollDown();
        }
    }

    async gotoSearchPage() {
        console.log("gotoSearchPage");
        const modal = await this.modalController.create({
            component: SearchchatComponent,
        });
        modal.onDidDismiss().then((data) => {
            const product = data.data; // Here's your selected user!
            console.log("Tu producto: " + product.codigo);
            this.articulo = JSON.stringify(product);
            this.tipofichero = "articulo";
            this.tipomensaje = "articulo";
            this.previmagen = product.imagen;
            this.prevnombre = product.nombre;
            this.prevprecioVenta = product.precioVenta;
            this.prevcodigo = product.codigo;
            this.preview = true;
            this.scrollDown();
        });

        return await modal.present();
    }

    // Go to product details page
    async goToProductDetails(item1) {
        console.log("goToProductDetails");
        console.log(item1);
        const modal = await this.modalController.create({
            component: ProductDetailsComponent,
            componentProps: { producto: item1 },
        });
        return await modal.present();
    }

    sendMessage(tipo) {
        
        console.log(tipo);

        let extension = "";
        if (tipo === "documento") {
            // Puede ser que se haya elegido un archivo imagen, el cual puedo mostrar como imagen
            extension = "jpg";
            try {
                extension = this.nombreFichero.substring(this.nombreFichero.lastIndexOf(".") + 1).toLowerCase();
            } catch {}
            if (extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "bmp") {
                tipo = "imagen";
            }
        } else if (tipo === "imagen") {
            extension = "jpg";
        }

        if (tipo === "imagen") {
            this.enviaFichero(this.message, "imagen", extension);
        } else if (tipo === "documento") {
            this.enviaFichero(this.message, "documento", extension);
        } else if (tipo === "articulo") {
            this.enviaArticulo(this.message);
        } else {
            this.enviaMensaje(this.message);
        }
    }

    async enviaFichero(mensaje, tipo, extension) {
        await this.apiService.chatMensaje(mensaje, tipo, this.archivo, extension);
        //await this.cargaChat(this.getUltimoIDObtenido(), this.resultado.id+1, this.chats.length);
        this.cargaUltimos();
        this.message = "";
        this.scrollDown();
        this.global.itemChat = undefined;
        this.preview = false;
        this.nombreFichero = "";
        this.archivo = null;
    }

    async enviaArticulo(mensaje) {
        this.resultado = await this.apiService.chatMensaje(mensaje, "articulo", this.articulo, "");
        this.message = "";
        //await this.cargaChat(this.getUltimoIDObtenido(), this.resultado.id+1, this.chats.length);
        await this.cargaUltimos();
        this.scrollDown();
        this.articulo = null;
        this.global.itemChat = undefined;
        this.preview = false;
        this.prevcodigo = "";
        this.articulo = null;
    }

    async enviaMensaje(mensaje) {
        this.resultado = await this.apiService.chatMensaje(mensaje, "mensaje", this.articulo, "");
        this.message = "";
        //await this.cargaChat(this.getUltimoIDObtenido(), this.resultado.id+1, this.chats.length);
        await this.cargaUltimos();
        this.scrollDown();
        this.articulo = null;
        this.global.itemChat = undefined;
        this.preview = false;
        this.prevcodigo = "";
        this.articulo = null;
    }

    onFileSelect(event) {
        if (event.target.files.length > 0) {
            this.archivo = event.target.files[0];
            console.log(this.archivo.size);
        }
    }

    showOptionsToggle(value?: boolean) {
        if (value !== undefined) {
            this.showOptions = value;
            return;
        }
        this.showOptions = !this.showOptions;
        this.scrollDown();
    }

    async captureImage(sourceType) {
        this.preview = false;
        this.options.sourceType = sourceType;
        await this.camera.getPicture(this.options).then(
            (imageData) => {
                // imageData is either a base64 encoded string or a file URI
                // If it's base64 (DATA_URL):
                let base64Image = "data:image/jpeg;base64," + imageData;
                this.rutaFichero = base64Image;
                //this.base64toblob(base64Image);
                const bytes: string = atob(imageData);
                const byteNumbers = new Array(bytes.length);
                for (let i = 0; i < bytes.length; i++) {
                    byteNumbers[i] = bytes.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                this.archivo = new Blob([byteArray], { type: "image/jpeg" });
                this.preview = true;
                this.tipofichero = "imagen";
                this.tipomensaje = "imagen";
                this.scrollDown();
            },
            (err) => {
                console.log(err);
                // Handle error
            }
        );
    }

    userTyping(event: any) {
        // console.log(event);
        this.start_typing = event.target.value;
        this.scrollDown();
    }

    // Go to cart page function
    async gotoCartPage() {
        this.dismiss();
        const modal = await this.modalController.create({
            component: CartComponent,
        });
        return await modal.present();
    }

    // Back to previous page function
    dismiss() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }
}
